module.exports = __webpack_public_path__ + "static/img/tvoc.78d7399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tvoc.png
// module id = UpvU
// module chunks = 1